export const optionsGrossFrom = [
    {
      label:'2020',
      value:'2020'
    },
    {
      label:'2021',
      value:'2021'
    },
    {
      label:'2022',
      value:'2022'
    }
  ]
  export const optionsGrossTo = [
    {
      label:'2021',
      value:'2021'
    },
    {
      label:'2022',
      value:'2022'
    },
    {
      label:'2023',
      value:'2023'
    }
  ]
  export const optionsNetFrom = [
    {
      label:'2020',
      value:'2020'
    },
    {
      label:'2021',
      value:'2021'
    },
    {
      label:'2022',
      value:'2022'
    }
  ]
  export const optionsNetTo = [
    {
      label:'2021',
      value:'2021'
    },
    {
      label:'2022',
      value:'2022'
    },
    {
      label:'2023',
      value:'2023'
    },
    {
      label:'2024',
      value:'2024'
    }
  ]